import { render } from "./LiveTVPlayer.vue?vue&type=template&id=44d3645d&scoped=true"
import script from "./LiveTVPlayer.vue?vue&type=script&lang=js"
export * from "./LiveTVPlayer.vue?vue&type=script&lang=js"

import "./LiveTVPlayer.vue?vue&type=style&index=0&id=44d3645d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d3645d"]])

export default __exports__